export default "/048cb1f2b29308e18768c65cfd51e426596a830c/a92d826d80900dda6092d3b109ffaee1.svg";